import {
  AssetDetectionMetricsSchema,
  type AssetDetectionMetricsDto,
} from '@terra/shared-contracts-external-network';

function readString({
  raw,
  keys,
}: {
  raw: Record<string, unknown>;
  keys: readonly string[];
}): string | null {
  for (const key of keys) {
    const value = raw[key];

    if (typeof value === 'string' && value.length > 0) {
      return value;
    }
  }

  return null;
}

export function readExternalAssetCloudProvider({
  raw,
}: {
  raw: Record<string, unknown>;
}): string | null {
  return readString({
    raw,
    keys: ['resolvedCloudProvider', 'cloudProvider', 'provider'],
  });
}

export function readExternalAssetDetectionMetrics({
  raw,
}: {
  raw: Record<string, unknown>;
}): AssetDetectionMetricsDto | undefined {
  const parsed = AssetDetectionMetricsSchema.safeParse(raw.detectionMetrics);

  return parsed.success ? parsed.data : undefined;
}

export function readHostnames({
  raw,
}: {
  raw: Record<string, unknown>;
}): string[] {
  const hostnames = raw.hostnames;

  if (!Array.isArray(hostnames)) {
    return [];
  }

  return hostnames.filter(
    (hostname): hostname is string => typeof hostname === 'string',
  );
}

export function readExternalAssetOpenPorts({
  raw,
}: {
  raw: Record<string, unknown>;
}): number[] {
  const openPorts = raw.openPorts;

  if (!Array.isArray(openPorts)) {
    return [];
  }

  return openPorts.filter((port): port is number => typeof port === 'number');
}

export function readExternalAssetTlsEnabled({
  raw,
}: {
  raw: Record<string, unknown>;
}): boolean {
  return raw.tlsEnabled === true;
}

export function formatHostPortsTooltip({
  openPorts,
}: {
  openPorts: number[];
}): string {
  return openPorts.join(', ');
}

export function formatHostPortsPreview({
  openPorts,
}: {
  openPorts: number[];
}): string {
  if (openPorts.length <= 4) {
    return openPorts.join(', ');
  }

  return `${openPorts.slice(0, 4).join(', ')} +${openPorts.length - 4}`;
}
